import React from 'react';
import ImagingDatasetViewerContainer from '@src/js/components/common/imaging/components/viewer/ImagingDatasetViewerContainer.jsx';
import { ImagingDataProvider } from '@src/js/components/common/imaging/components/viewer/ImagingDataContext.jsx'

//Component needed as uniqe access point for the context provider, to avoid changing DatabaseComponent.jsx

const ImagingDatasetViewer = ({onUnsavedChanges, objId, objType, extOpenbis, showSemanticAnnotations, imageIndex, previewIndex}) => {
	return (
		<ImagingDataProvider onUnsavedChanges={onUnsavedChanges}
			objId={objId}
			objType={objType}
			extOpenbis={extOpenbis}
			showSemanticAnnotations={showSemanticAnnotations}
			imageIndex={imageIndex}
			previewIndex={previewIndex} >
			<ImagingDatasetViewerContainer />
		</ImagingDataProvider>
	);
};

export default ImagingDatasetViewer;
